var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifyingGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 21",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.92285 0C10.7463 0 13.8465 3.09944 13.8467 6.92285L13.8369 7.2793C13.7939 8.12802 13.5961 8.93562 13.2744 9.67676L20.6455 17.0479C21.4261 17.8289 21.4263 19.0951 20.6455 19.876C19.8646 20.6569 18.5985 20.6566 17.8174 19.876L10.6797 12.7383C9.59753 13.439 8.30798 13.8467 6.92285 13.8467L6.56641 13.8369C2.90866 13.6513 0 10.6267 0 6.92285C0.00014379 3.09953 3.09953 0.000143793 6.92285 0ZM6.92285 3C4.75638 3.00014 3.00014 4.75638 3 6.92285C3 9.08944 4.7563 10.8465 6.92285 10.8467C9.08953 10.8467 10.8467 9.08953 10.8467 6.92285C10.8465 4.7563 9.08944 3 6.92285 3Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/magnifying-glass.a5d7ca368e66cb0fe8318ecd77b5bb47.svg";
export { ForwardRef as ReactComponent };